import {StyledEngineProvider, ThemeProvider} from "@mui/material"
import React from "react"
import AppBrowserRouter from "@app-core/AppBrowserRouter/AppBrowserRouter"
import {AuthProvider} from "auth/AuthContext"
import {EligibilityApplicationProvider} from "hooks/useEligibilityApplication"
import {MessagesProvider} from "hooks/useMessages"
import theme from "theme"
import Layout from "views/layouts/Layout"

function App() {
  return (
    <AppBrowserRouter>
      <MessagesProvider>
        <AuthProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <EligibilityApplicationProvider>
                <Layout />
              </EligibilityApplicationProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </AuthProvider>
      </MessagesProvider>
    </AppBrowserRouter>
  )
}

export default App
